module.exports = __webpack_public_path__ + "static/media/sjunga.2633edbd.mp3";